import React from 'react';
import { Icon } from 'rmwc';

export default ({ children }) => (
  <div className="hrbr-hint">
    <Icon>info</Icon> {children}
  </div>
);
